'use client';

import { ReactNode, useContext, useRef } from "react";
import './mobile-layout.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { usePathname, useRouter } from "next/navigation";
import { ROUTES } from "@/lib/routes";
import { HOME_SLIDE } from "@/components/Mobile/Home/slides";
import { useAmbientScramble } from '@/lib/hooks/useAmbientScramble';
import MobileShellContext from "@/components/Mobile/MobileShellContext";

const MobileLayout = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const pathname = usePathname();
  const { slide, setSlide, openDirectory, isShowreelMuted, toggleShowreelMuted } = useContext(MobileShellContext);
  const isOnShowreel = pathname === ROUTES.home && slide === HOME_SLIDE.title;

  const containerRef = useRef<HTMLDivElement>(null);

  useAmbientScramble(containerRef);

  const goHome = () => {
    setSlide(HOME_SLIDE.title);
    router.push(ROUTES.home);
  };

  return (
    <>
      <video
        className="mobile-dirt-bg-video"
        src="/assets/gif/DIRT.webm"
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="mobile-container" ref={containerRef}>
        <header className="header-mobile">
          <div className='header-left-container'>
            <div className="logo-mobile-container" onClick={goHome}>
              <img
                src="/assets/gif/BLOB.webp"
                alt="Blob"
                className="logo-mobile-image"
                width={129}
                height={120}
                fetchPriority="high"
              />
            </div>
            <div className={'title-header letter-scrambler'}>THE OTHER LAB CO.</div>
          </div>
          <div className='header-right-container'>
            {isOnShowreel && (
              <button
                type='button'
                className='header-button'
                aria-pressed={!isShowreelMuted}
                onClick={toggleShowreelMuted}
              >
                <span className='audio-indicator-mobile'>
                  <span>SOUND</span>
                  <span className='audio-icon' aria-hidden='true'>{isShowreelMuted ? 'OFF' : 'ON'}</span>
                </span>
              </button>
            )}
            <button
              type='button'
              className='hamburger-button'
              onClick={openDirectory}
              aria-label='Open directory menu'
            >
              <img
                src='/assets/image/mobile/Hamburger.svg'
                alt=''
                aria-hidden='true'
              />
            </button>
          </div>
        </header>
        <main className="content-mobile">
          {children}
        </main>
      </div>
    </>
  )
};
export default MobileLayout;
